import { IconButton, Tooltip, useColorMode, useColorModeValue } from "@chakra-ui/react";
import { SunIcon, MoonIcon } from "@chakra-ui/icons";

export default function ColorModeToggle() {
  const { colorMode, toggleColorMode } = useColorMode();
  const isDark = colorMode === "dark";
  const sunColor = useColorModeValue("gray.700", "yellow.300");
  const moonColor = useColorModeValue("gray.600", "orange.200");

  return (
    <Tooltip label={isDark ? "Switch to light mode" : "Switch to dark mode"} openDelay={300}>
      <IconButton
        aria-label="Toggle color mode"
        size="sm"
        onClick={toggleColorMode}
        icon={
          isDark
            ? <SunIcon color={sunColor} />
            : <MoonIcon color={moonColor} />
        }
        bg="transparent"
        variant="ghost"
      />
    </Tooltip>
  );
}